import { render, staticRenderFns } from "./overseasSearch.vue?vue&type=template&id=dd75c068&scoped=true&"
import script from "./overseasSearch.vue?vue&type=script&lang=js&"
export * from "./overseasSearch.vue?vue&type=script&lang=js&"
import style0 from "./overseasSearch.vue?vue&type=style&index=0&id=dd75c068&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd75c068",
  null
  
)

export default component.exports